import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TimeSlotsData } from 'src/app/models/consultdoctors';
import { SelectItem } from 'primeng/api';
import { DateUtilService, moment_duration } from 'src/app/utilities/date.util.service';

@Component({
  selector: 'app-time-slots',
  templateUrl: './time-slots.component.html',
  styleUrls: ['./time-slots.component.css']
})
export class TimeSlotsComponent {
  @Input("timeSlotsData")
  timeSlotsData: TimeSlotsData = new TimeSlotsData();
  @Output('date_selected')
  date_selected: EventEmitter<Date> = new EventEmitter<Date>();
  @Output('slot_id_selected')
  slot_id_selected: EventEmitter<number> = new EventEmitter<number>();

  constructor(
    private readonly dateUtil: DateUtilService,
  ) { }

  onDateChange() {
    this.timeSlotsData.timeSlots = [];
    this.timeSlotsData.timeSlots_api_data = [];
    this.timeSlotsData.show_empty_messsage = false;
    this.timeSlotsData.selectedSlot = null;
    this.date_selected.emit(this.timeSlotsData.selectedDate);
  }

  slotsDataGenerate() {
    let temp: SelectItem[] = [];
    if (this.timeSlotsData.timeSlots_api_data == null || !this.timeSlotsData.timeSlots_api_data.length) {
      this.timeSlotsData.show_empty_messsage = true;
    }
    this.timeSlotsData.timeSlots_api_data.forEach((ele) => {
      const slot_time = this.dateUtil.dateFormat(this.dateUtil.addQuantity(ele.slot_time, 0, moment_duration.minutes), "hh:mm A");
      temp.push({
        label: slot_time,
        value: ele.slot_id
      });
    });
    this.timeSlotsData.timeSlots = temp;
  }

  onSlotSlected(slot: SelectItem) {
    this.timeSlotsData.selectedSlot = slot.value;
    this.slot_id_selected.emit(this.timeSlotsData.selectedSlot);
  }
}